import React from 'react'
import logo from '../images/logo.png'
import Socials from './Socials'

const Footer = () => {
  return (
    <footer>
      <a href={'https://sport-express.ru/'} target="_blank" rel="noreferrer">
        <img src={logo} alt=""/>
      </a>
      <a href='/' className='default-link' style={{'opacity':'0'}}>
        Политика конфиденциальности
      </a>
      <Socials/>
    </footer>
  )
}

export default Footer
